export const environment = {
  production: false,

  versionNumber: '6.2.0',
  environmentTitle: 'DEV',
  issuer: 'https://sts-acc.inforius.be',
  postLogoutRedirectUri: 'https://icourrier2nd-dev.myinforius.be',
  redirectUri: 'https://icourrier2nd-dev.myinforius.be/callback',
  clientId: 'icour_e1',
  oidc: true,
  userinfoEndpoint: 'https://sts-acc.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'icour.e1_f icont.e1_icour_f itemplate.api openid profile email iadm.e2_f ico.e2_iadm_f iaddress.api iscan.api_e2 offline_access',
  showDebugInformation: false,
  silentRefreshRedirectUri: 'https://icourrierfrontdev.z28.web.core.windows.net/silent-renew.html',
  responseType: 'code',
  requireHttps: true,
  baseUrl: 'https://icourrier2nd-dev.myinforius.be',
  apiGatewayBaseUrl: 'https://icourrierapigw-dev.myinforius.be',
  apiICourrierBaseUrl: 'https://icourrierapigw-dev.myinforius.be/iCourriers2nd/api/v2',
  apiICourrierJobsBaseUrl: 'https://icourrierapigw-dev.myinforius.be/iCourriersJobs2nd/api/v1',
  apiICourrierWorkflowsBaseUrl: 'https://icourrierapigw-dev.myinforius.be/iCourriersWorkflows2nd/api/v1',
  iDelibeUrl: 'https://idelibe2nd-dev.myinforius.be',
  iDelibeApi: 'https://idelibeapigw-dev.myinforius.be/iDelibe2nd',
  apiContactiCourrierV1BaseUrl: 'https://icourrierapigw-dev.myinforius.be/iContactsCourriers2nd/api/v1',
  apiContactiCourrierV2BaseUrl: 'https://icourrierapigw-dev.myinforius.be/iContactsCourriers2nd/api/v2',
  frontIAdminUrl: 'https://iadm2nd-dev.myinforius.be',
  iAdminApiBaseURL: 'https://iadmapigw-dev.myinforius.be/iAdm2nd/api/v1',
  apiContactAdminBaseUrl: 'https://iadmapigw-dev.myinforius.be/iContactsAdm2nd/api/v1',
  apiScanPath: '',
  apiScanRoot: 'https://api-acc-iscan.myinforius.be',
  baseUrlDocumentEditor: 'https://iadmapigw-dev.myinforius.be/iTemplate2nd/api/v2',
  iAddressBaseURL: 'https://iaddressapi-acc.azurewebsites.net/api/v1',
  baseUrlSign: 'https://fake-isign.be/eSign/api/v1/sign',
  showDocExportBtn: false,
  enableSpellCheck: false,
  enableLogConsole: true,
  apiRoots: [
    'https://icourrier2nd-dev.myinforius.be',
    'https://icourrierapigw-dev.myinforius.be',
    'https://idelibe2nd-dev.myinforius.be',
    'https://idelibeapigw-dev.myinforius.be/iDelibe2nd',
    'https://iadm2nd-dev.myinforius.be',
    'https://iadmapigw-dev.myinforius.be',
    'https://api-acc-iscan.myinforius.be',
    'https://iaddressapi-acc.azurewebsites.net/api/v1',
    'https://fake-isign.be/eSign/api/v1/sign',
  ],
};
